import {Translate} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import DatetimeFormat from '../datetime/DatetimeFormat';
import {interventionRole} from '../../utils/constant';

function ProjectDetails({interventions, project}) {
  const client = interventions.find(intervention => intervention.role === interventionRole.CLIENT);
  const closingDateVisible = project.closingDate || (!project.closingDate && !project.provisionalAcceptanceDate);

  function getClosingDate() {
    if (closingDateVisible) {
      return (
        <div
          data-id="closingDate"
          className="mb-3"
        >
          {project.closingDate ?
            <DatetimeFormat
              value={project.closingDate}
              format="shortDate"
            /> :
            <span>-</span>
          }
        </div>
      );
    }

    return (
      <div
        data-id="provisionalAcceptanceDate"
        className="mb-3"
      >
        <DatetimeFormat
          value={project.provisionalAcceptanceDate}
          format="shortDate"
        />
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title"><Translate value="project.details"/></div>
      </div>
      <h3><Translate value="project.address"/></h3>
      <div data-id="addressLine">{project.address.addressLine}</div>
      <div data-id="postCode-city">{project.address.postCode} {project.address.city}</div>
      <div data-id="region">{project.address.region}</div>
      {client &&
        <>
          <hr className="my-5"/>
          <h3><Translate value="intervention.role.CLIENT"/></h3>
          <div data-id="clientName">{client.organisation.fullName} {client.organisation.address && `(${client.organisation.address.postCode})`}</div>
          <div data-id="clientRegistrationNumber">{client.organisation.registrationNumber}</div>
        </>
      }
      <hr className="my-5"/>
      <h3><Translate value="project.openingDate"/></h3>
      <div data-id="openingDate"><DatetimeFormat
        value={project.openingDate}
        format="shortDate"
      /></div>
      <hr className="my-5"/>
      <h3><Translate value={closingDateVisible ? 'project.closingDate' : 'project.provisionalAcceptanceDate'}/></h3>
      {getClosingDate()}
      <hr className="my-5"/>
      <h3><Translate value="project.additionalNotes"/></h3>
      <div data-id="additionalNotes">{project?.additionalNotes || '-'}</div>
    </div>
  );
}

ProjectDetails.propTypes = {
  interventions: PropTypes.array.isRequired,
  project: PropTypes.object.isRequired
};

export default ProjectDetails;
